import { render, staticRenderFns } from "./q-table-column.vue?vue&type=template&id=6cec915d&scoped=true&"
import script from "./q-table-column.vue?vue&type=script&lang=js&"
export * from "./q-table-column.vue?vue&type=script&lang=js&"
import style0 from "./q-table-column.vue?vue&type=style&index=0&id=6cec915d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec915d",
  null
  
)

export default component.exports